import { useForm } from 'react-hook-form';
import { useContext } from 'react';
import styles from './ChangeBusinessHours.module.scss';
import { Grid } from '../../../../ui/components/PageBuilder/Grid/Grid';
import { Dropdown } from '../../../../ui/components/Dropdown/Dropdown';
import { InitialContext } from '../../../Layout/Layout';

interface BusinessHoursForm {
  beginHour: string;
  endHour: string;
  timeZone: string;
}

export const ChangeBusinessHours = () => {
  const { company } = useContext(InitialContext);
  const { register, setValue } = useForm<BusinessHoursForm>();
  return (
    <form className={styles.root}>
      <Grid gridColumns={4}>
        <Dropdown
          label="Inicio laboral"
          placeholder="Registra el fin del horario laboral"
          register={register('beginHour')}
          defaultValue={{
            placeholder: `${company?.startBusinessHour}:00`,
            value: company?.startBusinessHour,
          }}
          items={[
            {
              placeholder: '12:00',
              value: '12',
            },
          ]}
          SetValue={setValue}
          name="beginHour"
        />
        <Dropdown
          classname={styles.dropdown}
          label="Fin laboral"
          placeholder="Registra el fin del horario laboral"
          register={register('endHour')}
          defaultValue={{
            placeholder: `${company?.endBusinessHour}:00`,
            value: company?.endBusinessHour,
          }}
          items={[
            {
              placeholder: '12:00',
              value: '12',
            },
          ]}
          SetValue={setValue}
          name="endHour"
        />
        <Dropdown
          classname={styles.dropdown}
          label="Zona horaria"
          placeholder="Registra la zona horaria de tu negocio"
          register={register('timeZone')}
          defaultValue={{
            placeholder: `GMT${company?.timeZone}`,
            value: company?.timeZone,
          }}
          items={[
            {
              placeholder: 'GMT-6',
              value: '-6',
            },
          ]}
          readOnly
          SetValue={setValue}
          name="timeZone"
        />
      </Grid>
      <div className={styles.button}>123</div>
    </form>
  );
};
